import React from 'react'
import { Link } from 'react-router-dom'
import Logo from './Logo'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-navy-950 text-slate-300 border-t border-slate-800">
      {/* Main Footer Links & Info */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-12">
          {/* Col 1: Brand & Presentation */}
          <div className="space-y-4">
            <Logo variant="light" />
            <p className="text-slate-400 text-sm leading-relaxed">
              Transport4U er en ung og dynamisk transportvirksomhed med mere end 2 års erfaring inden for godstransport, temperaturstyret logistik og akutte ekspresopgaver.
            </p>
            <div className="pt-2">
              <span className="inline-flex items-center gap-2 text-xs text-sky-400 font-medium">
                <i className="fa-solid fa-shield-halved" aria-hidden="true" />
                Varerne er dækket af godsforsikring
              </span>
            </div>
          </div>

          {/* Col 2: Ydelser */}
          <div>
            <h3 className="text-xs font-bold text-white uppercase tracking-wider mb-4">
              Transportydelser
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/temperaturstyret-transport" className="hover:text-sky-400 transition-colors">
                  Temperaturstyret transport (-20°C til +25°C)
                </Link>
              </li>
              <li>
                <Link to="/ekspreslevering" className="hover:text-sky-400 transition-colors">
                  Ekspreslevering 24/7 & Akut transport
                </Link>
              </li>
              <li>
                <Link to="/ekspreslevering" className="hover:text-sky-400 transition-colors">
                  Dag-til-dag & Dag-til-i-dag kørsel
                </Link>
              </li>
              <li>
                <Link to="/temperaturstyret-transport" className="hover:text-sky-400 transition-colors">
                  Kølevarer, Frostvarer & Kontrolleret varme
                </Link>
              </li>
              <li>
                <Link to="/vores-biler" className="hover:text-sky-400 transition-colors">
                  Palletransport op til 8 europaller
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Kontakt & Adresse */}
          <div className="space-y-3">
            <h3 className="text-xs font-bold text-white uppercase tracking-wider mb-4">
              Direkte kontakt
            </h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-sky-400 mt-1" aria-hidden="true" />
                <div className="text-slate-300">
                  <strong className="text-white block font-medium">Transport4U</strong>
                  <span>Herningvej 108</span><br />
                  <span>8600 Silkeborg</span><br />
                  <span className="text-xs text-slate-400">CVR 44899345</span>
                </div>
              </div>

              <div className="flex items-center gap-3 pt-1">
                <i className="fa-solid fa-phone text-sky-400" aria-hidden="true" />
                <a
                  href="tel:+4550352035"
                  className="font-bold text-white hover:text-sky-400 transition-colors whitespace-nowrap"
                  aria-label="Ring 50 35 20 35"
                >
                  <span className="whitespace-nowrap">50 35 20 35</span>
                </a>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-sky-400" aria-hidden="true" />
                <a
                  href="mailto:transport4u.dk@gmail.com"
                  className="text-white hover:text-sky-400 transition-colors break-all"
                  aria-label="Send e-mail til transport4u.dk@gmail.com"
                >
                  transport4u.dk@gmail.com
                </a>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-solid fa-clock text-sky-400" aria-hidden="true" />
                <span className="text-slate-300 text-xs">
                  Modtagelse af ordrer døgnet rundt (24/7)
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom copyright line */}
        <div className="mt-12 pt-6 border-t border-slate-800/80 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-300">
          <p>© {currentYear} Transport4U • CVR 44899345. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-6">
            <span>Pålidelig godstransport og temperaturstyret logistik</span>
            <span className="text-slate-700">|</span>
            <span className="text-sky-400">Silkeborg</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
